module.exports = __webpack_public_path__ + "static/media/img_cooperation_mobile.2c609de0.png";